// @flow
import type { Reducer } from 'redux';

import { checkActionIsRouteAction } from 'modules/router/helpers';

import clearableReducer from './clearableReducer';
import type { Action } from '../types';

export function clearableByRouteReducer<S, T, A: Action<T>>(
  routes: string | string[],
  reducer: Reducer<S, A>,
) {
  return clearableReducer(
    (action) =>
      checkActionIsRouteAction(action) &&
      (typeof routes === 'string' ? action.type !== routes : !routes.includes(action.type)),
    reducer,
  );
}

export default clearableByRouteReducer;



// WEBPACK FOOTER //
// ./src/store/helpers/clearableByRouteReducer.js